
@if(settings.get('profile.showExtrasViewOptions')) {

    <div class="d-flex align-items-center gap-2">
        <span>{{'pr.extrasPresenatationStyle'|translate}}: </span>
        <p-selectbutton [options]="viewOptions" [(ngModel)]="carouselMode" optionLabel="label" optionValue="value" aria-labelledby="toggle view">
            <ng-template #item let-item>
                    @if (item.value == true) {
                        <span class="material-symbols-outlined">
                            view_carousel
                        </span>
                    }
                    @else {
                        <span class="material-symbols-outlined">
                            view_module
                        </span>
                    }
                    {{item.label}}
            </ng-template>
        </p-selectbutton>
    </div>
}

<div class="extras-container" #carouselTop [attr.data-testid]="'extras-container'">


    @if (carouselMode) {

        <p-carousel
        @fadeIn
        [value]="combinedExtras"
        [numVisible]="3"
        [numScroll]="3"
        [circular]="false"
        [responsiveOptions]="responsiveOptions">
            <ng-template let-extra #item>

               <ng-container *ngTemplateOutlet="extraItemTemplate; context: { $implicit: extra }"></ng-container>

            </ng-template>
            <ng-template #previousicon>
                <span class="material-symbols-outlined">
                    arrow_back
                </span>
            </ng-template>
            <ng-template #nexticon>
                <span class="material-symbols-outlined">
                    arrow_forward
                </span>
            </ng-template>
        </p-carousel>

    }
    @else {
        <div class="row">
            @for (extra of combinedExtras; track $index) {
                <div class="col-12 col-sm-6 col-lg-4 mb-3" @fadeIn>
                    <ng-container *ngTemplateOutlet="extraItemTemplate; context: { $implicit: extra }"></ng-container>
                </div>
            }
        </div>


    }


</div>


<!-- Template for single extra item -->
<ng-template #extraItemTemplate let-extra>
    <div class="extras-item" [attr.data-testid]="'extras-item'">
        <div class="extras-loader" [class.shown]="showLoaderId == extra.rateId">
            <p-progressSpinner strokeWidth="8"
                fill="transparent"
                animationDuration=".5s"
                [style]="{ width: '50px', height: '50px' }" />
        </div>
        <div class="extras-image-wrap">
            <!-- TODO: support for multiple images -->
            <img
            [src]="extra.imageUrl ?? extra.pim?.images?.[0]?.src ?? '/image-placeholder.jpeg'"
            [alt]="extra.pim?.name"
            class="extra-image" />
        </div>


        <div class="extra-texts">

            <h4 class="extra-title" [innerHTML]="extra.pim?.name ?? extra.extraName" [attr.data-testid]="'extras-title'">

            </h4>

            @if (extra.externalId) {
                <div class="external-date d-flex mb-2">
                    <span class="material-symbols-outlined">
                    event
                    </span>
                    {{extra.event.startDate|date:'dd.MM.yyyy HH:mm'}}@if(extra.event.endDate != extra.event.startDate){ - {{extra.event.endDate|date:'dd.MM.yyyy HH:mm'}}}

                </div>
                <div class="extra-description" [innerHTML]="extra.description" [attr.data-testid]="'extras-description'"></div>
            }
            @else {
                <app-truncated-text [text]="extra.pim?.shortDesc" [truncateHeight]="this.settings.get('profile.extraDescriptionMaxHeight')" [attr.data-testid]="'extras-description'"></app-truncated-text>
            }

            <div class="extra-price" [attr.data-testid]="'extras-price'">
                {{ getUnitPrice(extra) | currency }}
                @if (getPriceBreakdownKey(extra)) {
                    <span class="extra-price-breakdown">{{ getPriceBreakdownKey(extra) | translate }}</span>
                }
            </div>
            <app-extra-debugview [extra]="extra"></app-extra-debugview>


            <div class="extra-buttons" [class.singleElement]="shopCart.getCartItemsByType('roomrate').length == 1 && shopCart.getExtra(extra.rateId).length == 0">

                @if (shopCart.getExtra(extra.rateId).length > 0) {
                    <div class="extra-amount-summary-wrap">
                        <div class="extra-amount-summary-icon">
                            <span class="material-symbols-outlined">
                                receipt_long
                            </span>
                        </div>

                        <div class="extra-amount-summary">
                            @for (extraItem of shopCart.getExtra(extra.rateId); track $index) {
                                <span>
                                    @if (shopCart.getCartItemsByType('roomrate').length > 1) {
                                        <span class="extra-amount-summary-room">{{'pr.Room'|translate}} {{extraItem.roomIndex + 1}}: </span>
                                    }
                                    @if (extraItem.item.quantity > 1) {
                                        {{extraItem.item.quantity}} x {{extraItem.item.totalPriceForStayWithTaxes|currency}}
                                    }
                                    <span class="extra-amount-summary-price">{{extraItem.item.quantity * extraItem.item.totalPriceForStayWithTaxes|currency}}</span></span>
                                    @if (extraItem.item.calculationRule === 'adult') {
                                        <span class="extra-summary-note">{{ 'pr.extraNoteAdults' | translate: {count: shopCart.getFirstSearchParams().roomData[extraItem.roomIndex].adults} }}</span>
                                    }
                                    @if (extraItem.item.calculationRule === 'child') {
                                        <span class="extra-summary-note">{{ 'pr.extraNoteChildren' | translate: {count: shopCart.getFirstSearchParams().roomData[extraItem.roomIndex].children} }}</span>
                                    }
                                    @if (extraItem.item.calculationRule === 'person') {
                                        <span class="extra-summary-note">{{ 'pr.extraNotePersons' | translate: {count: shopCart.getFirstSearchParams().roomData[extraItem.roomIndex].adults + shopCart.getFirstSearchParams().roomData[extraItem.roomIndex].children} }}</span>
                                    }
                                    @if (extraItem.item.postingRhythm === 'day') {
                                        <span class="extra-summary-note">{{ 'pr.extraNoteDays' | translate: {count: shopCart.getDaysDelta()} }}</span>
                                    }
                            }
                        </div>

                    </div>
                    <p-button (onClick)="editExtra(extra)">{{"pr.editExtra"|translate}}</p-button>
                }
                @else {
                    @if (shopCart.getCartItemsByType('roomrate').length == 1) {
                        @switch (getExtraUiType(extra)) {
                            @case ('checkbox') {
                                <p-button icon outlined (onClick)="editExtra(extra)" [attr.data-testid]="'open-extra-info'">
                                    <span class="material-symbols-outlined">info</span>
                                </p-button>
                                <p-button (onClick)="addExtraSingleRoom(extra, 1)" [attr.data-testid]="'add-extra'">{{"pr.AddExtra"|translate}}</p-button>
                            }
                            @case ('fixed') {
                                    @if (extra.calculationRule === 'adult') {
                                        <span class="extra-fixed-qty">{{ 'pr.extraFixedAdults' | translate: {count: getExtraAutoQty(extra)} }}</span>
                                    } @else if (extra.calculationRule === 'child') {
                                        <span class="extra-fixed-qty">{{ 'pr.extraFixedChildren' | translate: {count: getExtraAutoQty(extra)} }}</span>
                                    } @else if (extra.calculationRule === 'person') {
                                        <span class="extra-fixed-qty">{{ 'pr.extraFixedPersons' | translate: {count: getExtraAutoQty(extra)} }}</span>
                                    }
                           
                                <p-button icon outlined (onClick)="editExtra(extra)" [attr.data-testid]="'open-extra-info'">
                                    <span class="material-symbols-outlined">info</span>
                                </p-button>
                                <p-button (onClick)="addExtraSingleRoom(extra, 1)" [attr.data-testid]="'add-extra'">{{"pr.AddExtra"|translate}}</p-button>
                            }
                            @default {
                                <app-incrementor
                                    #incrementor
                                    [value]="1"
                                    [minValue]="1"
                                    [maxErrorText]="'pr.extraMaxValue'|translate:{value: getExtraMaxQty(extra)}"
                                    [maxValue]="getExtraMaxQty(extra)"
                                    class="w-50"
                                    dataTestId="extra-card">
                                </app-incrementor>
                                <p-button icon outlined (onClick)="editExtra(extra)" [attr.data-testid]="'open-extra-info'">
                                    <span class="material-symbols-outlined">info</span>
                                </p-button>
                                <p-button (onClick)="addExtraSingleRoom(extra, incrementor.value)" [attr.data-testid]="'add-extra'">{{"pr.AddExtra"|translate}}</p-button>
                            }
                        }
                    }
                    @else {
                        <p-button class="ms-auto" (onClick)="editExtra(extra)" [attr.data-testid]="'add-through-edit-extra'">{{"pr.AddExtra"|translate}}</p-button>
                    }
                }

            </div>

        </div>


    </div>
</ng-template>

<!-- Edit dialog -->

<app-edit-extra-dialog [extrasToEdit]="extrasToEdit" [unitPrice]="extrasToEdit ? getUnitPrice(extrasToEdit[0]) : null" [unitPriceLabel]="extrasToEdit ? getPriceBreakdownKey(extrasToEdit[0]) : ''" (onClose)="hideEditExtraDialog()" (onChangeQuantity)="updateEditExtraQuantity($event.event, $event.index)" [testId]="'extra-dialog-info'"></app-edit-extra-dialog>
